import { PropsWithChildren, useRef } from 'react';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';

/** Hero entrance animation on mount (no ScrollTrigger). */
export default function HeroAnimated({ children, className }: PropsWithChildren<{ className?: string }>) {
  const root = useRef<HTMLDivElement | null>(null);

  useGSAP(
    () => {
      if (!root.current) return;
      const blocks = root.current.querySelectorAll('[data-hero-item]');
      gsap.from(blocks.length ? blocks : root.current, {
        opacity: 0,
        y: 28,
        duration: 0.75,
        ease: 'power2.out',
        stagger: 0.08,
      });
    },
    { scope: root },
  );

  return (
    <div ref={root} className={className}>
      {children}
    </div>
  );
}
